//third-party
import { useNavigate } from "react-router-dom";
//styles
import "./BackButton.scss";
//icons
import HomeIcon from "../../Icons/HomeIcon";

function BackButton() {
	const navigate = useNavigate();
	const hadleBackClick = () => {
		navigate("/");
		window.location.reload();
	};
	return <HomeIcon width={2.5} height={2.5} func={hadleBackClick} />;
}

export default BackButton;
